import React from 'react'
import { Container, Stack, Heading, SimpleTabs } from '@/components/lib'
import useStore from '../../store'
import utils from '../../utils/utils.js'
import useTitle from '../../hooks/useTitle'
import Overview from './Overview'
import Users from './Users'
import Integrations from './Integrations'
import Settings from './Settings'
import Branding from './Branding'
import Events from './Events'
import Login from '../entry/Login'

function Team () {
  const { user, team } = useStore()
  useTitle('Manage Team')

  if (!user) return <Login withWarning />

  const tabs = [
    { title: 'Overview', content: <Overview />, to: '/team/overview' },
    { title: 'Branding', content: <Branding />, to: '/team/branding' },
    { title: 'Settings', content: <Settings />, to: '/team/settings' },
    { title: 'Users', content: <Users />, to: '/team/users' },
    { title: 'Integrations', content: <Integrations />, to: '/team/integrations' }
  ]
  if (utils.canManageTeam(user, team)) {
    tabs.push(
      { title: 'Logs', content: <Events />, to: '/team/events' }
    )
  }

  return (
    <Container>
      <Stack gap={5}>
        <Heading size='lg'>{team ? team.name + '\'s' : 'Your'} team account</Heading>
        {team &&
          <SimpleTabs lazy tabs={tabs} />}
      </Stack>
    </Container>
  )
}

export default Team
